var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9939 5.61671H13.5939V15.6167H11.9939V5.61671Z",
    fill: "color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.994 18.6166C13.994 19.2793 13.4567 19.8166 12.794 19.8166C12.1312 19.8166 11.594 19.2793 11.594 18.6166C11.594 17.9539 12.1312 17.4166 12.794 17.4166C13.4567 17.4166 13.994 17.9539 13.994 18.6166Z",
    fill: "color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.793945 12.6167C0.793945 6.0167 6.19395 0.616699 12.7939 0.616699C19.3939 0.616699 24.7939 6.0167 24.7939 12.6167C24.7939 19.2167 19.3939 24.6167 12.7939 24.6167C6.19395 24.6167 0.793945 19.2167 0.793945 12.6167ZM23.194 12.6167C23.194 6.81674 18.594 2.21674 12.794 2.21674C6.99398 2.21674 2.39398 6.81674 2.39398 12.6167C2.39398 18.4167 6.99398 23.0167 12.794 23.0167C18.594 23.0167 23.194 18.4167 23.194 12.6167Z",
    fill: "color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.0e37277e0a19e2b367c26d33605484d5.svg";
export { ForwardRef as ReactComponent };